import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

export const orgDataRouteRef = createRouteRef();

const orgDataPage = PageBlueprint.make({
  params: {
    path: '/org-data',
    noHeader: true,
    routeRef: orgDataRouteRef,
    loader: () =>
      import('./components/OrgDataPage').then(m => <m.OrgDataPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'org-data',
  extensions: [orgDataPage],
});
